import { useState, useCallback } from 'react';

/**
 * Custom hook for smooth modal close animations
 * @param {Function} onClose - The original close function
 * @param {number} animationDuration - Duration in milliseconds (default: 300)
 * @returns {Object} - { isClosing, handleClose }
 */
export const useModalClose = (onClose, animationDuration = 300) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    // Simple, reliable timeout that matches CSS animation duration
    setTimeout(() => {
      onClose();
    }, animationDuration);
  }, [onClose, animationDuration]);

  return { isClosing, handleClose };
};
